function Marquee(selector, speed) {
    const track = document.querySelector(`${selector} .marquee-track`);

    // duplicate once (not twice)
    track.innerHTML += track.innerHTML;

    let position = 0;

    function animate() {
        position += speed;
        track.style.transform = `translateX(-${position}px)`;

        if (position >= track.scrollWidth / 2) {
            position = 0;
        }

        requestAnimationFrame(animate);
    }

    animate();
}

window.addEventListener('load', function () {
    Marquee('.octobuddy-marquee', 0.3);
});